var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49935 7.23638C2.49935 6.9449 2.65165 6.6746 2.90096 6.52359L9.56763 2.48575C9.833 2.32502 10.1657 2.32502 10.4311 2.48575L17.0977 6.52359C17.3471 6.6746 17.4993 6.9449 17.4993 7.23638L17.4994 16.0648C17.4994 16.6273 17.0433 17.0833 16.4808 17.0833H3.51787C2.95536 17.0833 2.49935 16.6273 2.49935 16.0648V7.23638Z",
    stroke: "#121833",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 11.6673C9.16602 11.2071 9.53911 10.834 9.99935 10.834C10.4596 10.834 10.8327 11.2071 10.8327 11.6673V17.5007H9.16602V11.6673Z",
    fill: "#121833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.99fc481bec08b90d5667dd84c9768bd0.svg";
export { ForwardRef as ReactComponent };